import gql from 'graphql-tag';

export const FeedFollowQuery = gql`
	query FeedFollowQuery {
		getFeedUserConfig {
			accountIds
		}
	}
`;
